// @ts-nocheck
import { useMemo, useState } from 'react';
import ImageGalleryOverlay from '@/components/common/ImageGalleryOverlay/ImageGalleryOverlay';
import './TaskSkuImagePreview.css';

const CDN_BASE_URL = 'https://dezshop.fra1.cdn.digitaloceanspaces.com/production/uploads/products';

const toSmallUrl = (img: any) => {
  if (!img) return '';
  if (img.small) return img.small;
  if (img.thumbnail) return img.thumbnail;
  if (img.url) return String(img.url).replace('/large/', '/small/');
  if (img.image) return `${CDN_BASE_URL}/small/${img.image}`;
  if (img.large) return String(img.large).replace('/large/', '/small/');
  return '';
};

const toLargeUrl = (img: any) => {
  if (!img) return '';
  if (img.large) return img.large;
  if (img.url) return String(img.url).replace('/small/', '/large/');
  if (img.image) return `${CDN_BASE_URL}/large/${img.image}`;
  if (img.small) return String(img.small).replace('/small/', '/large/');
  if (img.thumbnail) return String(img.thumbnail).replace('/small/', '/large/');
  return '';
};

const normalizeImages = (images: any) => {
  const list = Array.isArray(images) ? images : [];
  return list
    .map((img: any) => {
      const small = toSmallUrl(img);
      const large = toLargeUrl(img);
      return {
        small,
        large: large || small,
        isCover: Boolean(img?.isCover || img?.cover),
      };
    })
    .filter((img: any) => Boolean(img.small || img.large));
};

const TaskSkuImagePreview = ({
  images = [],
  alt = 'Imagine piesa',
  thumbSize = 96,
}: any) => {
  const [galleryState, setGalleryState] = useState({
    isOpen: false,
    initialIndex: 0,
  });

  const normalizedImages = useMemo(() => normalizeImages(images), [images]);
  const coverIndex = useMemo(() => {
    const idx = normalizedImages.findIndex((img: any) => img.isCover);
    return idx >= 0 ? idx : 0;
  }, [normalizedImages]);
  const primaryImage = normalizedImages[coverIndex] || normalizedImages[0] || null;
  const hoverPreviewUrl = primaryImage?.large || primaryImage?.small || '';

  const galleryImages = useMemo(() => (
    normalizedImages.map((img: any, index: number) => ({
      url: img.large || img.small,
      thumbnail: img.small || img.large,
      alt: `${alt} ${index + 1}`,
    }))
  ), [normalizedImages, alt]);

  const openGallery = (e: any) => {
    e?.stopPropagation?.();
    if (galleryImages.length === 0) return;
    setGalleryState({
      isOpen: true,
      initialIndex: coverIndex,
    });
  };

  if (!primaryImage) {
    return (
      <div
        className="task-image-placeholder"
        style={{ '--task-thumb-size': `${thumbSize}px` } as any}
      >
        <span className="text-[10px] text-gray-400">—</span>
      </div>
    );
  }

  return (
    <>
      <div className="task-images-cell">
        <button
          type="button"
          className={`task-image-wrapper${hoverPreviewUrl ? '' : ' no-hover-preview'}`}
          onClick={openGallery}
          onMouseMove={(e: any) => {
            e.currentTarget.style.setProperty('--cursor-x', `${e.clientX}px`);
            e.currentTarget.style.setProperty('--cursor-y', `${e.clientY}px`);
          }}
          style={{
            '--task-hover-image-url': `url('${hoverPreviewUrl}')`,
            '--task-thumb-size': `${thumbSize}px`,
          } as any}
        >
          <img
            draggable={false}
            src={primaryImage.small || primaryImage.large}
            alt={alt}
            className={`task-sku-thumbnail${primaryImage.isCover ? ' cover-image' : ''}`}
            loading="lazy"
          />
          {normalizedImages.length > 1 && (
            <span className="task-more-images">+{normalizedImages.length - 1}</span>
          )}
        </button>
      </div>
      <ImageGalleryOverlay
        isOpen={galleryState.isOpen}
        onClose={() => setGalleryState((prev: any) => ({ ...prev, isOpen: false }))}
        images={galleryImages}
        initialIndex={galleryState.initialIndex}
      />
    </>
  );
};

export default TaskSkuImagePreview;
